import { render, staticRenderFns } from "./EditPlan.vue?vue&type=template&id=45efd2a0&scoped=true"
import script from "./EditPlan.vue?vue&type=script&lang=js"
export * from "./EditPlan.vue?vue&type=script&lang=js"
import style0 from "./EditPlan.vue?vue&type=style&index=0&id=45efd2a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_cache-loader@4.1.0_webpack@4.47.0__css-load_84b6d598d32b1da7294c0119ce301628/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45efd2a0",
  null
  
)

export default component.exports